// 导入模块、服务
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { CommonModule } from "@angular/common";
import { AppComponent } from "./app.component";
import { UserModule } from "./user/user.module";
import { AppRoutingModule } from "./app.routing.module";
import { LoginService } from "./service/login/login.service";
import { AuthGuard } from "./service/auth/auth.guard";
import { Router } from "@angular/router";
import { NgLeafletModule } from "./ng-leaflet/ng-leaflet.module";
import { UtilService } from "./service/util.service";



// 导入三方库
import { NgZorroAntdModule, NZ_MESSAGE_CONFIG, NZ_I18N, zh_CN } from "ng-zorro-antd";
import { InputTextModule } from "primeng/inputtext";
import { DataTableModule, OrderListModule, CardModule, PanelModule } from "primeng/primeng";
import { AccordionModule } from "primeng/accordion";
import { TabViewModule } from "primeng/tabview";
import { OverlayPanelModule } from "primeng/overlaypanel";

// 导入组件
// 首页
import { HomeComponent } from "./home/home.component";
import { HomeLayoutComponent } from './home-layout/home-layout.component'; // 导入 HomeLayoutComponent
// 走进中心
import { EnterCenterComponent } from './enterCenter/enter-center/enter-center.component';
import { CenterOverviewComponent } from './enterCenter/center-overview/center-overview.component'
import { CenterProgressComponent } from './enterCenter/center-progress/center-progress.component';
import { CenterViewComponent } from './enterCenter/center-view/center-view.component';
import { OrganizationComponent } from './enterCenter/organization/organization.component'
// 中心服务
import { CentralServicesComponent } from './centralServices/central-services/central-services.component'
import { ComplexMappingComponent } from "./centralServices/complex-mapping/complex-mapping.component";
import { DataIntroduceComponent } from "./centralServices/data-introduce/data-introduce.component";
import { NatureComponent } from "./centralServices/nature/nature.component";
import { ProductionComponent } from "./centralServices/production/production.component";
import { SkyLandComponent } from "./centralServices/sky-land/sky-land.component";
import { SpaceInfoComponent } from "./centralServices/space-info/space-info.component";
import { ThreeSComponent } from "./centralServices/three-s/three-s.component";
// 信息动态
import { InfoVarietyComponent } from './information/info-variety/info-variety.component';
import { CenterNewsComponent } from "./information/center-news/center-news.component";
import { IndustryNewsComponent } from "./information/industry-news/industry-news.component";
import { NoticeAnnouncementComponent } from "./information/notice-announcement/notice-announcement.component";
// 数据管理
import { DataManagerComponent } from './manager/data-manager/data-manager.component'
import { CartComponent } from "./manager/cart/cart.component";
import { DataQueryComponent } from "./manager/data-query/data-query.component";
import { DownloadComponent } from "./manager/download/download.component";
import { CartService } from "./manager/service/cart.service";
// 行业应用
import { IndustryAppComponent } from "./industryApplication/industry-app/industry-app.component";
import { SthjComponent } from './industryApplication/sthj/sthj.component';
import { YjglComponent } from './industryApplication/yjgl/yjgl.component';
import { ZrzyComponent } from "./industryApplication/zrzy/zrzy.component";
import { ZhfzComponent } from "./industryApplication/zhfz/zhfz.component";
import { LycyComponent } from "./industryApplication/lycy/lycy.component";
import { CxzjComponent } from "./industryApplication/cxzj/cxzj.component";
import { WwbhComponent } from "./industryApplication/wwbh/wwbh.component";
import { JtysComponent } from "./industryApplication/jtys/jtys.component";
import { NyncComponent } from "./industryApplication/nync/nync.component";
import { GyssComponent } from "./industryApplication/gyss/gyss.component";
import { HsgsComponent } from "./industryApplication/hsgs/hsgs.component";
// 综合体系
import { ServiceExampleComponent } from './serviceCase/service-example/service-example.component';
import { ServiceCaseComponent } from "./serviceCase/service-case/service-case.component";
// 星群资源
import { OtherSatComponent } from "./starResources/other-sat/other-sat.component";
import { OutsideSatComponent } from "./starResources/outside-sat/outside-sat.component";
import { ProductDisplayComponent } from "./starResources/product-display/product-display.component";
import { StarResourcesComponent } from "./starResources/star-resources/star-resources.component";
// 政策规定
import { NationregulationsComponent } from "./policyregulations/nationregulations/nationregulations.component"; 
import { ProvinceregulationsComponent } from "./policyregulations/provinceregulations/provinceregulations.component"; 
import { CenterregulationsComponent } from "./policyregulations/centerregulations/centerregulations.component";
import { PolicyRegulationsComponent } from "./policyregulations/policy-regulations/policy-regulations.component";
// 联系我们
import { ContactWaysComponent } from "./contactUs/contact-ways/contact-ways.component";
import { TalentSeekComponent } from "./contactUs/talent-seek/talent-seek.component";
import { ContactUsComponent } from './contactUs/contact-us/contact-us.component';
// components部分
import { HeaderComponent } from "./components/header/header.component";
import { FooterComponent } from './components/footer/footer.component';

// 杂乱部分
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LayoutComponent } from "./layout/layout.component";
import { DetailComponent } from './detail/detail.component';
import { PolicyDetailComponent } from './policy-detail/policy-detail.component';
// 配置 i18n
import { registerLocaleData } from "@angular/common";
import zh from "@angular/common/locales/zh";



registerLocaleData(zh);

@NgModule({
  declarations: [
    // 首页
    HomeComponent,
    HomeLayoutComponent,
    // 走进中心
    EnterCenterComponent,
    CenterOverviewComponent,
    CenterProgressComponent,
    CenterViewComponent,
    OrganizationComponent,
    // 中心服务
    CentralServicesComponent,
    ComplexMappingComponent,
    DataIntroduceComponent,
    NatureComponent,
    ProductionComponent,
    SkyLandComponent,
    SpaceInfoComponent,
    ThreeSComponent,
    // 信息动态
    InfoVarietyComponent,
    CenterNewsComponent,
    IndustryNewsComponent,
    NoticeAnnouncementComponent,
    // 数据管理
    DataManagerComponent,
    CartComponent,
    DataQueryComponent,
    DownloadComponent,
    // 行业应用
    IndustryAppComponent,
    SthjComponent,
    YjglComponent,
    ZrzyComponent,
    ZhfzComponent,
    LycyComponent,
    CxzjComponent,
    WwbhComponent,
    JtysComponent,
    NyncComponent,
    GyssComponent,
    HsgsComponent,
    // 综合体系
    ServiceExampleComponent,
    ServiceCaseComponent,
    // 星群资源
    StarResourcesComponent,
    OtherSatComponent,
    OutsideSatComponent,
    ProductDisplayComponent,
    //政策规定
    PolicyRegulationsComponent,
    NationregulationsComponent,
    ProvinceregulationsComponent,
    CenterregulationsComponent,
    // 联系我们
    ContactUsComponent,
    ContactWaysComponent,
    TalentSeekComponent,
    // components部分
    HeaderComponent,
    FooterComponent,
    // 杂乱部分
    AppComponent,
    LayoutComponent,
    DetailComponent,
    PolicyDetailComponent
  ],
  imports: [
    AppRoutingModule, // app路由模块
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgLeafletModule.forRoot(),
    /** 导入 ng-zorro-antd 模块 **/
    NgZorroAntdModule,
    UserModule, // user子模块
    CommonModule,
    DataTableModule,
    AccordionModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    InputTextModule,
    NgLeafletModule,
    NgZorroAntdModule,
    OverlayPanelModule,
    TabViewModule,
    CardModule,
    PanelModule,
  ],
  providers: [
    CartService,
    {
      // hash路由
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    /** 配置 ng-zorro-antd 国际化 **/
    { provide: NZ_I18N, useValue: zh_CN },
    LoginService,
    UtilService,
    AuthGuard // 登录保护guard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  // 审查路由配置
  constructor(private router: Router) {
    // console.log("路由：", JSON.stringify(router.config, undefined, 2));
  }
}
